import React from "react";
import { Helmet } from "react-helmet-async";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";

const PageNoticeDetailsExterneLoading: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <SpinnerEditeurPro />
    </>
  );
};

export default PageNoticeDetailsExterneLoading;
